import TransactionManagement from "./transaction-management.page";

export default TransactionManagement;
